import { render, staticRenderFns } from "./modalOsReforco.vue?vue&type=template&id=e456d6ca&scoped=true"
import script from "./modalOsReforco.vue?vue&type=script&lang=js"
export * from "./modalOsReforco.vue?vue&type=script&lang=js"
import style0 from "./modalOsReforco.vue?vue&type=style&index=0&id=e456d6ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e456d6ca",
  null
  
)

export default component.exports